import { format } from "date-fns";

const DATE_FORMAT = "MMM d";

/**
 * Formats date for Source Usage chart X-axis (e.g. "Jan 14").
 */
export function formatSourceUsageDate(date: Date | string): string {
  const d = typeof date === "string" ? new Date(date) : date;
  return format(d, DATE_FORMAT);
}
